import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "mt-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_catalog_product__details = _resolveComponent("g-catalog-product__details");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        "show-header": true,
        title: _ctx._title,
        "class-content": "content__no-marging"
    }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: "Schließen",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.currentWindow.close(2))),
                type: "normal",
                class: "w-120-px"
            })
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_g_catalog_product__details, {
                    "product-number": _ctx.productNumber,
                    "item-number": _ctx.itemNumber,
                    onProductLoaded: _ctx.onProductLoaed
                }, null, 8, ["product-number", "item-number", "onProductLoaded"])
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
